import { RefreshCw } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { BrandButton } from "@/components/kit/BrandButton";
import { useAuth } from "@/lib/auth";

/** FluentCart Free has no purchase webhook, so the reader can pull instead of waiting for the
 *  15-minute cache: this re-reads purchases from WordPress immediately. */
export const RefreshPurchases = () => {
  const { refreshEntitlements } = useAuth();
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await refreshEntitlements();
      toast.success("Purchases refreshed from Plattershare.");
    } catch {
      toast.error("Could not reach Plattershare just now. Your current access is unchanged.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2 sm:max-w-[280px] sm:text-right">
      <BrandButton
        name="refresh-purchases"
        variant="outline"
        onClick={run}
        disabled={busy}
        className="w-full border-brand-orange text-brand-orange hover:border-brand-orange hover:bg-brand-peach sm:w-auto"
      >
        <RefreshCw className={`h-4 w-4 ${busy ? "animate-spin" : ""}`} /> Refresh purchases
      </BrandButton>
      <p
        data-testid="refresh-purchases-note"
        className="text-[12px] leading-relaxed text-muted-foreground"
      >
        Just upgraded? Your new access may take up to 10–15 minutes to appear. Tap Refresh purchases to
        check for your latest purchase.
      </p>
    </div>
  );
};
